import React from 'react';
import { InlineInputCardWrapper } from '@/features/editor/widgets/ai-component/inputs/shared/shared';
import { SwitchInput } from '@/features/editor/widgets/ai-component/inputs/shared/switch-input';

export interface GenericJsBooleanInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function GenericJsBooleanInput({
  value,
  onChange,
}: GenericJsBooleanInputProps) {
  const onSwitchChange = (_, stringValue?: string) => {
    onChange?.(stringValue);
  };

  return (
    <InlineInputCardWrapper>
      <span>Boolean Input</span>
      <SwitchInput initialValue={value} onChange={onSwitchChange} />
    </InlineInputCardWrapper>
  );
}
